import React from 'react';
import { TextField, ImageDrop } from '../ui.jsx';

const SOCIALS = [['facebook', 'Facebook'], ['x', 'X (Twitter)'], ['instagram', 'Instagram'], ['linkedin', 'LinkedIn'], ['youtube', 'YouTube'], ['tiktok', 'TikTok']];
const bad = (v) => v && !/^https?:\/\/\S+$/i.test(v);

/** Step 2 — profile picture, name, occupation, bio and social links. */
export default function AboutStep({ ctx }) {
  const { page, patch, assets, upload, remove, busy } = ctx;
  const setAbout = (k, v) => patch({ about: { ...page.about, [k]: v } });
  const setSocial = (k, v) => patch({ about: { ...page.about, socials: { ...page.about.socials, [k]: v } } });

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-lg font-semibold">About Me</h3>
        <p className="text-xs text-white/60">This section sets up how your leads will see you. Upload a picture of yourself, set your name, and your occupation.</p>
      </div>

      <div>
        <ImageDrop label={assets.profile ? 'Replace profile picture (max 5MB)' : 'Upload profile picture (max 5MB)'} onFile={(f) => upload('profile', f)} busy={busy} testId="pp-profile-upload" />
        {assets.profile && <button type="button" className="mt-1 text-xs text-rose-300 underline" onClick={() => remove('profile')}>Remove profile picture</button>}
      </div>

      <TextField label="Your name" value={page.about.name} onChange={(v) => setAbout('name', v)} maxLength={80} required testId="pp-name" />
      <TextField label="Your occupation" value={page.about.occupation} onChange={(v) => setAbout('occupation', v)} maxLength={80} required testId="pp-occupation" />
      <TextField label="About me text" value={page.about.text} onChange={(v) => setAbout('text', v)} multiline rows={6} maxLength={2000} required testId="pp-about-text" />

      <div>
        <h4 className="text-base font-semibold">Social media links (optional)</h4>
        <p className="mb-3 text-xs text-white/60">Paste the entire link, starting with https://</p>
        <div className="space-y-3">
          {SOCIALS.map(([k, label]) => (
            <TextField key={k} label={label} value={page.about.socials[k]} onChange={(v) => setSocial(k, v)} error={bad(page.about.socials[k]) ? 'Use a full link starting with https://' : ''} />
          ))}
        </div>
      </div>
    </div>
  );
}
